export enum CompartmentStates {
  Unknown = "Unknown",
  Closed = "Closed",
  Opened = "Opened"
}

export class Compartment {
  number: string = "";
  state: CompartmentStates = CompartmentStates.Unknown;
  sizeId: string = "";
  packagingOptionsIds: string[] = [];
}
